<template>
    <CRow alignVertical="center">
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("SFTP Integration") }}
                </CCardHeader>
                <CCardBody>
                    <SelectAsync
                        :label="$t('SFTP Integration')"
                        :placeholder="
                            $t('Select a SFTP integration')
                        "
                        :horizontal="
                            defaultSelectConfig.horizontal
                        "
                        size="sm"
                        :value.sync="
                            valueComponent.sftpIntegrationId
                        "
                        optionsValue="uuid"
                        optionsLabel="name"
                        endpoint="connector.api/integrations"
                        :fetchConfig="{
                            params: {
                                query: {
                                    where: {
                                        driver_id: {
                                            equal:
                                                $options.consts.SFTP_PLUGIN_ID,
                                        },
                                    },
                                },
                            },
                        }"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Upload remote path") }}
                </CCardHeader>
                <CCardBody>
                    <CInput
                        :value.sync="valueComponent.uploadRemotePath"
                        :placeholder="
                            $t('Enter the upload remote path')
                        "
                        :label="$t('Upload remote path')"
                        :horizontal="defaultInputConfig.horizontal"
                        :size="size" 
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("To") }}
                </CCardHeader>
                <CCardBody>
                    <TagsInput
                        :label="$t('To')"
                        :horizontal="defaultInputConfig.horizontal"
                        :value.sync="valueComponent.to"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Cc") }}
                </CCardHeader>
                <CCardBody>
                    <TagsInput
                        :label="$t('Cc')"
                        :horizontal="defaultInputConfig.horizontal"
                        :value.sync="valueComponent.cc"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Cco") }}
                </CCardHeader>
                <CCardBody>
                    <TagsInput
                        :label="$t('Cco')"
                        :horizontal="defaultInputConfig.horizontal"
                        :value.sync="valueComponent.cco"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Is html") }}
                </CCardHeader>
                <CCardBody>
                    <CCSwitch
                        :checked.sync="valueComponent.isHtml"
                        :label="$t('Is html')"
                        :horizontal="{
                            label: 'col-sm-2',
                            input: 'col-sm-10',
                        }"
                        color="primary"
                        name="action"
                        shape="pill"
                        variant="3d"
                        size="sm"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Subject upload notification") }}
                </CCardHeader>
                <CCardBody>
                    <CInput
                        :value.sync="valueComponent.subjectUploadNotification"
                        :placeholder="
                            $t('Enter the subject upload notification email')
                        "
                        :label="$t('Subject upload notification')"
                        :horizontal="defaultInputConfig.horizontal"
                        :size="size"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Message upload notification") }}
                </CCardHeader>
                <CCardBody>
                    <CTextarea
                        :value.sync="valueComponent.messageUploadNotification"
                        :placeholder="
                            $t('Enter the message upload notification')
                        "
                        :label="$t('Message upload notification')"
                        :horizontal="defaultInputConfig.horizontal"
                        size="sm"
                        rows="10"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Subject password") }}
                </CCardHeader>
                <CCardBody>
                    <CInput
                        :value.sync="valueComponent.subjectPassword"
                        :placeholder="$t('Enter the subject password email')"
                        :label="$t('Subject password')"
                        :horizontal="defaultInputConfig.horizontal"
                        size="sm"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Message password") }}
                </CCardHeader>
                <CCardBody>
                    <CTextarea
                        :value.sync="valueComponent.messagePassword"
                        :placeholder="$t('Enter the message password')"
                        :label="$t('Message password')"
                        :horizontal="defaultInputConfig.horizontal"
                        size="sm"
                        rows="10"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("Signature") }}
                </CCardHeader>
                <CCardBody>
                    <CTextarea
                        :value.sync="valueComponent.signature"
                        :placeholder="$t('Enter the signature')"
                        :label="$t('Signature')"
                        :horizontal="defaultInputConfig.horizontal"
                        :size="size"
                        rows="10"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    {{ $t("File configuration") }}
                </CCardHeader>
                <CCardBody>
                    <CCFileConfiguration
                        :value.sync="valueComponent.file"
                        :size="size"
                        :horizontal="defaultInputConfig.horizontal"
                    >
                    </CCFileConfiguration>
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    <h5>
                        {{ $t("Fields mapping") }}
                    </h5>
                </CCardHeader>
                <CCardBody>
                    <TableMappingFields
                        :value.sync="valueComponent.mappingFields"
                    />
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="12" sm="12">
            <CCard>
                <CCardHeader>
                    <h5>
                        {{ $t("Fixed fields") }}
                    </h5>
                </CCardHeader>
                <CCardBody>
                    <p class="mb-0">
                        {{
                            $t(
                                "You can create fixed fields for your integration"
                            )
                        }}.
                    </p>
                    <CCTableAddItems
                        :items.sync="valueComponent.fixedFields"
                        :fields="defaultFixedFieldsFields"
                        noItemsViewText="Add fixed field"
                    >
                        <template #name="{ item }">
                            <CInput
                                :value.sync="item.name"
                                :placeholder="$t('Enter the name')"
                                :invalidFeedback="$t('Name is required')"
                                class="mb-0"
                                size="sm"
                            />
                        </template>
                        <template #value="{ item }">
                            <CInput
                                :value.sync="item.value"
                                :placeholder="$t('Enter the value')"
                                :invalidFeedback="$t('Value is required')"
                                class="mb-0"
                                size="sm"
                            />
                        </template>
                    </CCTableAddItems>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import TableFixedFields from "~/components/TableFixedFields.vue";
import TableMappingFields from "~/components/TableMappingFields.vue";
import CCFileConfiguration from "./CCFileConfiguration.vue";
import CCTable from "~/components/CCTable";
import CCTableAddItems from "~/components/CCTableAddItems.vue";
import TagsInput from "~/components/TagsInput.vue";
import ButtonAdd from "~/components/ButtonAdd";
import SelectAsync from "£lement/SelectAsync";
import SelectTags from "£lement/SelectTags";
import CCSwitch from "~/components/CCSwitch";

import tableMixin from "~/mixins/table.js";
import baseMixin from "~/mixins/base.js";

import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import SelectFields from "£lement/SelectFields";
import { SFTP_PLUGIN_ID } from "../config/consts";

export default {
    name: "CCMethodSftpConfiguration",
    mixins: [baseMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {
        SFTP_PLUGIN_ID,
    },
    options: {},
    components: {
        TableFixedFields,
        TableMappingFields,
        CCTable,
        CCTableAddItems,
        SelectAsync,
        ButtonAdd,
        SelectTags,
        SelectFields,
        TagsInput,
        CCSwitch,
        CCFileConfiguration,
    },
    data() {
        return {
            valueComponent: {
                sftpIntegrationId: null,
                uploadRemotePath: null, 
                to: [],
                cc: [],
                cco: [],
                subjectUploadNotification: "",
                subjectPassword: "",
                messageUploadNotification: "",
                messagePassword: "",
                signature: "",
                isHtml: false,
                file: {
                    name: null,
                    format: null,
                    delimiter: null,
                    enclosure: null,
                    compressed: false,
                    password: null,
                },
                fixedFields: [],
                mappingFields: [],
            },

            defaultFixedFieldsFields: [
                {
                    key: "name",
                    label: "Field name",
                },
                {
                    key: "value",
                    label: "Field value",
                },
            ],
        };
    },
    props: {
        value: {
            required: true,
        },
        size:{
            default: "md"
        }
    },
    watch: {
        value(newValue) {
            if (newValue) {
                this.valueComponent = newValue;
            }
        },
        valueComponent: {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },
    methods: {},
    async mounted() {
        if (this.value) {
            this.valueComponent = this.value;
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
